import { render, staticRenderFns } from "./HumanResourcesMatrixBlock.vue?vue&type=template&id=18047b4a"
import script from "./HumanResourcesMatrixBlock.vue?vue&type=script&lang=js"
export * from "./HumanResourcesMatrixBlock.vue?vue&type=script&lang=js"
import style0 from "./HumanResourcesMatrixBlock.vue?vue&type=style&index=0&id=18047b4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports